var gFadeTime = 500;
var gSlideTime = 30000;
var gImgFadeTime = 500;
var slidesInfo = new Array();

$(document).ready(function ($) {
	
	var slideCount = $('#slider .slider-hidden').length;
	for (var i = 0; i < slideCount; i++) {
		// hidden slides order: newest first
		var slideInfo = new Array( 
		                $('.slider-hidden .slider-data-color').eq(i).text(),
		                $('.slider-hidden .slider-data-img').eq(i).html(),
		                $('.slider-hidden .slider-data-title').eq(i).text(),
		                $('.slider-hidden .slider-data-title-align').eq(i).text(),
		                $('.slider-hidden .slider-data-content').eq(i).html(),
		                $('.slider-hidden .slider-data-btn').eq(i).html())
		slidesInfo.push(slideInfo);
	}
	
	if (slidesInfo.length > 0) {
		setInterval(function() {
			slidesInfo.push(slidesInfo.shift());
			controlSlider(slidesInfo[0]);
		}, gSlideTime);
	}
	
	function controlSlider(slide) {
		$('#slider .slider-big').attr('class', 'site-slider slider-big color-'+slide[0]);
		$('#slider').fadeOut(gFadeTime, function() {
			$('.slider-title h2, .slider-small-title').text(slide[2]);
			//small sliders can show title on the left or right
			if (slide[3] == 'right') {
				$('.slider-small-title').css({ left: 'auto', right: '0' });
			} else {
				$('.slider-small-title').css({ left: '30px', right: 'auto' });
			}
			$('#slider .slider-content').html(slide[4]);
			$('#slider .slider-btn').html(slide[5]);
			$('#slider').fadeIn(gFadeTime);
		});
		
		$('#slider .slider-img').fadeOut(gImgFadeTime, function() {
			$('#slider .slider-img').html(slide[1]);
			$('#slider .slider-img').fadeIn(gImgFadeTime);
		});
	}
	
	$('.slider-left').click(function () {
		slidesInfo.unshift(slidesInfo.pop());
		controlSlider(slidesInfo[0]);
	});
	
	$('.slider-right').click(function () {
		slidesInfo.push(slidesInfo.shift());
		controlSlider(slidesInfo[0]);
	});

});

// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
